import { createRouter, createWebHashHistory } from "vue-router";
import { getJson } from "../api/client";
import { getAccessToken, logout } from "../lib/auth";
import { hasSessionOrgId, setSessionOrgId } from "../lib/config";
import type { PrincipalMe } from "../types/identity";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("../pages/LoginPage.vue"),
      meta: { title: "登录", public: true },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("../pages/RegisterPage.vue"),
      meta: { title: "注册", public: true },
    },
    {
      path: "/auth/callback",
      name: "auth-callback",
      component: () => import("../pages/AuthCallbackPage.vue"),
      meta: { title: "登录回调", public: true },
    },
    {
      path: "/",
      component: () => import("../layouts/AppLayout.vue"),
      children: [
        {
          path: "",
          name: "home",
          component: () => import("../pages/HomePage.vue"),
          meta: { title: "首页" },
        },
        {
          path: "assets",
          name: "assets",
          component: () => import("../pages/AssetsPage.vue"),
          meta: { title: "产品库" },
        },
        {
          path: "collector",
          component: () => import("../layouts/CollectorHubLayout.vue"),
          meta: { title: "机器人巡查" },
          children: [
            {
              path: "",
              name: "collector",
              component: () => import("../pages/CollectorPage.vue"),
              meta: { title: "机器人巡查" },
            },
            {
              path: "tasks",
              name: "crawl-tasks",
              component: () => import("../pages/CrawlTasksPage.vue"),
              meta: { title: "巡查任务" },
            },
            {
              path: "compare-history",
              name: "compare-history",
              component: () => import("../pages/CompareHistoryPage.vue"),
              meta: { title: "比对历史" },
            },
            {
              path: "compare-trial",
              name: "compare-trial",
              component: () => import("../pages/CompareTrialPage.vue"),
              meta: { title: "比对测试" },
            },
          ],
        },
        {
          path: "competitors",
          name: "competitors",
          component: () => import("../pages/CompetitorsPage.vue"),
          meta: { title: "竞品库" },
        },
        {
          path: "suspects",
          name: "suspects",
          component: () => import("../pages/SuspectsPage.vue"),
          meta: { title: "疑似审核" },
        },
        {
          path: "cases",
          name: "cases",
          component: () => import("../pages/CasesPage.vue"),
          meta: { title: "维权案件" },
        },
        {
          path: "compare-trial",
          redirect: "/collector/compare-trial",
        },
        {
          path: "compare-history",
          redirect: "/collector/compare-history",
        },
        {
          path: "ingestion",
          name: "ingestion",
          component: () => import("../pages/IngestionPage.vue"),
          meta: { title: "入库验证" },
        },
        {
          path: "admin",
          redirect: "/settings/admin",
        },
        {
          path: "settings",
          component: () => import("../layouts/SettingsHubLayout.vue"),
          meta: { title: "系统设置" },
          children: [
            {
              path: "",
              name: "settings",
              component: () => import("../pages/SettingsPage.vue"),
              meta: { title: "系统设置" },
            },
            {
              path: "admin",
              name: "admin",
              component: () => import("../pages/AdminPage.vue"),
              meta: { title: "组织管理" },
            },
          ],
        },
        {
          path: "billing",
          name: "billing",
          component: () => import("../pages/BillingPage.vue"),
          meta: { title: "订阅订购", allowExpired: true },
        },
      ],
    },
  ],
});

router.beforeEach(async (to) => {
  if (to.meta.public) return true;
  if (!getAccessToken() && to.name !== "login") {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  if (getAccessToken() && !hasSessionOrgId()) {
    try {
      const me = await getJson<PrincipalMe>("/v1/auth/me");
      setSessionOrgId(me.orgId);
    } catch {
      logout();
      return { name: "login", query: { redirect: to.fullPath } };
    }
  }
  return true;
});

router.afterEach((to) => {
  const title = typeof to.meta.title === "string" ? to.meta.title : "工作台";
  document.title = `品哨 · ${title}`;
});

export default router;
